import { Box, Image, Text, CloseButton } from '@frontend/components';

const Header = ({ title, subtitle, onClose }) => {
  return (
    <Box
      alignItems="center"
      backgroundColor="brand.secondary"
      flexDirection="row"
      justifyContent="space-between"
      minHeight={18}
      position="relative"
    >
      <CloseButton
        position="absolute"
        top={2.5}
        right={2.5}
        onClick={onClose}
        colorScheme="onInteraction"
        size="lg"
        sx={{
          '&:hover': {
            color: 'brand.secondary',
          },
          '&:active': {
            color: 'brand.secondary',
          },
        }}
      />
      <Box p={4}>
        <Text color="white" fontWeight="heavy" size="3xl">
          {title}
        </Text>
        <Text color="white" fontWeight="medium" my={1} size="xl">
          {subtitle}
        </Text>
      </Box>
      <Image
        alt="Geometry Background"
        display={{ base: 'none', desktop: 'block' }}
        h="100%"
        position="absolute"
        src="https://s3.amazonaws.com/static.paperlessparts.com/images/geometry_background_1.png"
        radioGroup={0}
        top={0}
      />
    </Box>
  );
};

export default Header;
